import { render } from "./Icons.sptite.vue?vue&type=template&id=c3f077ce"
const script = {}

import "./Icons.sptite.vue?vue&type=style&index=0&id=c3f077ce&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__